import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';

import Section, {
  SectionHeader, SectionTitle, SectionBody, SectionBodyEmptyContent,
} from 'components/common/Section';
import Button from 'components/common/Button';
import IconPlus from 'components/icons/IconPlus';
import IconNotepad from 'components/icons/IconNotepad';

import VitalsItem from './VitalsItem';
import VitalsCreateDialog from './VitalsCreateDialog';

const styles = () => ({
  iconPlus: {
    width: 14,
    height: 14,
    marginRight: 10,
  },
  button: {
    marginLeft: 20,
  },
  iconNotepad: {
    width: 18,
    height: 22,
  },
});

class Vitals extends Component {
  constructor(props) {
    super(props);

    this.state = {
      addDialogOpen: false,
    };

    this.onAddButtonClick = this.onAddButtonClick.bind(this);
    this.onAddDialogClose = this.onAddDialogClose.bind(this);
  }

  onAddButtonClick() {
    this.setState({ addDialogOpen: true });
  }

  onAddDialogClose() {
    this.setState({ addDialogOpen: false });
  }

  render() {
    const {
      classes,
      patient,
      business,
    } = this.props;

    return (
      <Section>
        <SectionHeader>
          <SectionTitle>
            Vitals
          </SectionTitle>
          <Button
            className={classes.button}
            variant="raised"
            disabled={!patient}
            onClick={this.onAddButtonClick}
          >
            <IconPlus className={classes.iconPlus} />
            Add
          </Button>
        </SectionHeader>
        <SectionBody
          {...(!patient || patient.Vitals.length === 0) ? { padding: 'none' } : {}}
        >
          {(!patient || patient.Vitals.length === 0) ? (
            <SectionBodyEmptyContent
              text="There are no vitals yet"
              icon={(
                <IconNotepad className={classes.iconNotepad} />
              )}
            />
          ) : (
            <Table>
              <TableBody>
                {
                  patient.Vitals.map(item => (
                    <VitalsItem
                      key={item.ID}
                      {...{ 'Record Number': patient['Record Number'] }}
                      {...item}
                      business={business}
                    />
                  ))
                }
              </TableBody>
            </Table>
          )}
        </SectionBody>
        {patient !== null &&
          <VitalsCreateDialog
            open={this.state.addDialogOpen}
            onClose={this.onAddDialogClose}
            {...{ 'Record Number': patient['Record Number'] }}
          />
        }
      </Section>
    );
  }
}

Vitals.propTypes = {
  patient: PropTypes.shape({
    'Record Number': PropTypes.number,
    Vitals: PropTypes.arrayOf(PropTypes.shape({
      ID: PropTypes.number.isRequired,
    })),
  }),
  business: PropTypes.shape({
    ID: PropTypes.number,
    'Time Zone': PropTypes.string,
  }),
  classes: PropTypes.shape({
    iconPlus: PropTypes.string.isRequired,
    iconNotepad: PropTypes.string.isRequired,
    button: PropTypes.string.isRequired,
  }).isRequired,
};

Vitals.defaultProps = {
  patient: null,
  business: {},
};

export default withStyles(styles)(Vitals);



// WEBPACK FOOTER //
// ./src/components/patient/PatientProfile/Vitals/Vitals.js